<script>
import TablePage from '@/found/components/table_page';
import Modal from '@/found/components/modal';
import Form from './components/newDetail';

export default {
  extends: TablePage,
  name: 'history_data_main_list',
  components: {
    Modal,
    Form,
  },
  data() {
    return {
      // requestType: 'GET',
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: '',
      },
    };
  },
  created() {
    this.getConfigList('history_data_main_list');
  },
  methods: {
    setColumn(v) {
      const item = v;
      if (item.field === 'cycleCode') {
        item.search = 'true';
        item.title = '结算周期';
        item.type = 'select';
        item.apiUrl = '/cps/v1/fxhCycleConfig/findByConditions';
        item.optionsKey = {
          label: 'cycleName',
          value: 'cycleCode',
        };
        item.isSearch = true;
        item.paramsName = 'cycleName';
      }
      return item;
    },
    // 按钮点击事件
    modalClick({ val, row }) {
      console.log({ val, row });
      console.log('this.formConfig', this.formConfig);

      if (['add', 'edit', 'view'].includes(val.code)) {
        this.formConfig = {};
        this.formName = 'Form';
        if (val.code === 'view') {
          this.modalConfig.title = '详情';
        }
        this.modalConfig.width = '70%';
        this.modalConfig.height = '600px';
        this.formConfig = {
          type: val.code,
          id: row.id || '',
          code: val.code || '',
          terminalCode: row.terminalCode || '',
        };
        this.openFull();
      }
    },
  },
};
</script>
